import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c989578"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-cell" }),
  /*#__PURE__*/_createElementVNode("div", { class: "name-cell" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserListTableHeaderCell = _resolveComponent("UserListTableHeaderCell")!

  return (_openBlock(), _createElementBlock("div", {
    class: "user-list-table-header-container",
    style: _normalizeStyle(_ctx.styles)
  }, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shownColumns, (column) => {
      return (_openBlock(), _createBlock(_component_UserListTableHeaderCell, {
        key: column.id,
        class: "cell",
        text: column.name,
        width: column.width,
        height: _ctx.height
      }, null, 8, ["text", "width", "height"]))
    }), 128))
  ], 4))
}